import { render, staticRenderFns } from "./ReportAnnulmentEditor.vue?vue&type=template&id=5475b4a8&scoped=true&"
import script from "./ReportAnnulmentEditor.vue?vue&type=script&lang=js&"
export * from "./ReportAnnulmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReportAnnulmentEditor.vue?vue&type=style&index=0&id=5475b4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475b4a8",
  null
  
)

export default component.exports